<script>
    function ito_logout() {
        if (confirm("退出登录，是否继续")) {
            CommonLib.setAppStorage("iotdc_cur_nickname", "");
            CommonLib.setAppStorage("iotdc_cur_cnname", "");
            CommonLib.setAppStorage("iotdc_cur_permits", "[]");
            window.location = "/dbapi/logout";
        }
    }
</script>

<nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
        <li class="nav-item">
            <a
                class="nav-link"
                data-widget="pushmenu"
                href={"javascript:;"}
                role="button"><i class="bi bi-list" /></a
            >
        </li>
        <li class="nav-item d-none d-sm-inline-block">
            <a href={"javascript:;"} class="nav-link">平台首页</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
            <a href={"javascript:;"} class="nav-link">数据看板</a>
        </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
        <!-- Messages Dropdown Menu -->
        <li class="nav-item dropdown">
            <a class="nav-link" data-toggle="dropdown" href={"javascript:;"}>
                <i class="bi bi-chat-square" title="公告信息" />
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <a href={"javascript:;"} class="dropdown-item">
                    系统上线通知
                </a>
                <div class="dropdown-divider" />
                <a href={"javascript:;"} class="dropdown-item">
                    系统测试通知
                </a>
                <div class="dropdown-divider" />
                <a href={"javascript:;"} class="dropdown-item">
                    放假通知
                </a>
                <div class="dropdown-divider" />
                <a href={"javascript:;"} class="dropdown-item dropdown-footer"
                    >查看所有公告信息</a
                >
            </div>
        </li>
        <!-- Notifications Dropdown Menu -->
        <li class="nav-item dropdown">
            <a class="nav-link" data-toggle="dropdown" href={"javascript:;"}>
                <i class="bi bi-bell" title="报警信息" />
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <a href={"javascript:;"} class="dropdown-item">
                    传感器01报警
                </a>
                <div class="dropdown-divider" />
                <a href={"javascript:;"} class="dropdown-item">
                    传感器02报警
                </a>
                <div class="dropdown-divider" />
                <a href={"javascript:;"} class="dropdown-item">
                    传感器03报警
                </a>
                <div class="dropdown-divider" />
                <a href={"javascript:;"} class="dropdown-item dropdown-footer"
                    >查看所有报警信息</a
                >
            </div>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                data-widget="fullscreen"
                href={"javascript:;"}
                role="button"
            >
                <i class="bi bi-arrows-fullscreen" title="切换全屏" />
            </a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                href={"javascript:;"}
                role="button"
                on:click={ito_logout}
            >
                <i class="bi bi-box-arrow-right" title="退出系统" />
            </a>
        </li>
    </ul>
</nav>

<style>
</style>
